<template>
  <div
    class="popover-dialog"
    :style="{
      width: 20 + 'vw',
      position: 'fixed',
      left: adjustedX + 'px',
      top: adjustedY + 'px',
      zIndex: 9999,
    }"
    @click.stop
  >
    <v-card elevation="8" rounded="lg">
      <!-- Title Bar -->
      <v-card-title class="d-flex justify-space-between align-center pb-0">
        <span></span>
        <v-btn icon x-small @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <!-- Deskripsi -->
        <div class="mb-4">
          <div class="d-flex align-start font-weight-medium mb-1">
            Deskripsi <span class="red--text">*</span>
          </div>
          <v-textarea
            ref="input_description"
            :readonly="!isDoctor"
            v-model="form.description"
            outlined
            dense
            rows="5"
            :rules="deskripsiRules"
            required
            :maxlength="500"
          />
        </div>

        <!-- Tipe Luka -->
        <div class="mb-4">
          <div class="d-flex align-start font-weight-medium mb-1">
            Tipe Luka
          </div>
          <v-select
            :readonly="!isDoctor"
            clearable
            v-model="form.woundType"
            outlined
            dense
            placeholder="Pilih atau ketik untuk lainnya"
            :items="injuryItem"
            hide-details
          />
        </div>

        <!-- Ukuran Luka -->
        <div class="mb-4">
          <div class="d-flex align-start font-weight-medium mb-1">
            Ukuran Luka
          </div>

          <!-- Panjang -->
          <div class="d-flex flex-column align-start mb-2">
            <label>Panjang</label>
            <div class="input-paint-grid">
              <v-text-field
                :readonly="!isDoctor"
                v-model="form.dimensions.length.value"
                outlined
                dense
                type="number"
                min="0"
                hide-details
              />
              <v-select
                :readonly="!isDoctor"
                v-model="form.dimensions.length.unit"
                outlined
                dense
                :items="satuanOptions"
                hide-details
              />
            </div>
          </div>

          <!-- Lebar -->
          <div class="d-flex flex-column align-start mb-2">
            <label>Lebar</label>
            <div class="input-paint-grid">
              <v-text-field
                :readonly="!isDoctor"
                v-model="form.dimensions.width.value"
                outlined
                dense
                type="number"
                min="0"
                hide-details
              />
              <v-select
                :readonly="!isDoctor"
                v-model="form.dimensions.width.unit"
                outlined
                dense
                :items="satuanOptions"
                hide-details
              />
            </div>
          </div>

          <!-- Kedalaman -->
          <div class="d-flex flex-column align-start mb-2">
            <label>Kedalaman</label>
            <div class="input-paint-grid">
              <v-text-field
                :readonly="!isDoctor"
                v-model="form.dimensions.depth.value"
                outlined
                dense
                type="number"
                min="0"
                hide-details
              />
              <v-select
                :readonly="!isDoctor"
                v-model="form.dimensions.depth.unit"
                outlined
                dense
                :items="satuanOptions"
                hide-details
              />
            </div>
          </div>
        </div>
      </v-card-text>

      <!-- Bottom Action Bar -->
      <v-card-actions class="d-flex justify-space-between px-4">
        <v-btn
          icon
          outlined
          color="primary"
          class="square-rounded-btn pa-4"
          x-small
          @click="handleDelete"
          :disabled="!isDoctor"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          class="square-rounded-btn pa-4"
          fab
          x-small
          @click="handleSubmit"
          :disabled="!isFormValid || !isDoctor"
        >
          <v-icon dark>mdi-send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'WoundFormDialog',

  props: {
    isDoctor: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    },
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
    markIdx: {
      type: Number,
      default: null,
    },
    injuryItem: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      adjustedX: 0,
      adjustedY: 0,
      form: {
        description: '',
        woundType: '',
        dimensions: {
          length: { value: '', unit: 'cm' },
          width: { value: '', unit: 'cm' },
          depth: { value: '', unit: 'cm' },
        },
      },
      satuanOptions: ['cm', 'mm'],
      deskripsiRules: [
        v => !!v || 'Deskripsi wajib diisi',
        v => (v && v.length >= 5) || 'Deskripsi minimal 5 karakter',
      ],
    };
  },

  computed: {
    isFormValid() {
      let valid = true;

      if (this.form.description === '') {
        valid = false;
      } else if (
        this.form.description.length < 5 ||
        this.form.description.length > 500
      ) {
        valid = false;
      }

      return valid;
    },
  },

  watch: {
    x: 'adjustPosition',
    y: 'adjustPosition',
  },

  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
    this.$nextTick(this.adjustPosition);
    this.mapInitialData();
    this.$refs.input_description.focus();
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },

  methods: {
    mapInitialData() {
      if (this.data) {
        this.form = this.data;
      } else {
        this.resetForm();
      }
    },
    adjustPosition() {
      this.$nextTick(() => {
        const popup = this.$el;
        if (!popup) return;

        const popupRect = popup.getBoundingClientRect();
        const margin = 10; // px from edge

        let newX = this.x;
        let newY = this.y;

        // Check right overflow
        if (newX + popupRect.width > window.innerWidth - margin) {
          newX = window.innerWidth - popupRect.width - margin;
        }
        // Check left overflow
        if (newX < margin) {
          newX = margin;
        }
        // Check bottom overflow
        if (newY + popupRect.height > window.innerHeight - margin) {
          newY = window.innerHeight - popupRect.height - margin;
        }
        // Check top overflow
        if (newY < margin) {
          newY = margin;
        }

        this.adjustedX = newX;
        this.adjustedY = newY;
      });
    },
    handleOutsideClick(e) {
      if (this.$el.contains(e.target)) {
        this.$emit('close');
      }
    },

    handleClose() {
      this.resetForm();
      const closeIdx =
        this.data && this.data?.description !== '' ? null : this.markIdx;

      this.$emit('close', closeIdx);
    },

    handleSubmit() {
      if (this.isFormValid) {
        this.$emit('save', { ...this.form });
      }
    },

    handleDelete() {
      this.$emit('delete', this.markIdx);
    },

    resetForm() {
      this.form = {
        description: '',
        woundType: '',
        dimensions: {
          length: { value: '', unit: 'cm' },
          width: { value: '', unit: 'cm' },
          depth: { value: '', unit: 'cm' },
        },
      };
    },
  },
};
</script>

<style scoped>
.popover-dialog {
  min-width: 200px;
}

.input-paint-grid {
  display: grid;
  grid-template-columns: 2fr 0.7fr;
  gap: 10px;
}

.square-rounded-btn {
  border-radius: 5px;
}
</style>
